import { CloseIcon } from '../../../assets/icons/Svg'
import { useDispatch } from 'react-redux'
import { clearTypeOfAdditionalModal } from '../../../features/modal/modalSlice'

export default function ClientPackagesHeader() {

    const dispatch = useDispatch()

    return (
        <div className="flex justify-between items-center py-1">
            <div>
                <p className="text-base font-semibold leading-tight text-slate-900">
                    Packages
                </p>
                <p className="mt-1 text-sm text-slate-500">
                    View packages and their included products.
                </p>
            </div>
            <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                onClick={() => dispatch(clearTypeOfAdditionalModal())}
            >
                <CloseIcon />
            </button>
        </div>
    )
}
